<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isPromptActiveLocal"
  >
    <div class="flex items-center justify-between px-6 form-header">
      <h4>Modifier une question</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isPromptActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div class="vx-row">
          <div class="w-full px-2">
            <p class="label">Question</p>
            <vs-input class="w-full" v-model="form.question" />
          </div>
        </div>
        <div class="vx-row mt-6">
          <div class="w-1/2 px-2">
            <p class="label">Type de question</p>
            <v-select
              class="w-full"
              label="name"
              placeholder="Selectionner"
              :reduce="(type) => type.id"
              :options="types"
              v-model="form.type_question"
            ></v-select>
          </div>
          <div class="w-1/2 px-2">
            <p class="label">Instruction</p>
            <vs-input class="w-full" v-model="form.instructions" />
          </div>
        </div>
        <hr class="mt-6" />
        <p class="section-title font-bold mt-8 mb-4">Réponses</p>
        <div class="row">
          <div v-if="form.type_question == 'text'">
            <p class="label">Renseignez la réponse</p>
            <vs-textarea rows="5" v-model="form.answers" class="w-full" />
          </div>
          <div v-if="form.type_question == 'checkbox'">
            <div
              class="answer_box mt-4"
              v-for="(item, key) in form.answers"
              :key="key"
            >
              <p class="text-black">Réponse # {{ key + 1 }}</p>
              <vs-textarea
                rows="4"
                v-model="item.answers"
                class="w-full"
              ></vs-textarea
              ><br />
              <div class="w-full" style="display: flex; flex-wrap: wrap">
                <div class="define_question">
                  <!-- {{ item.correct }} -->
                  <vs-checkbox color="#FFCC00" v-model="item.correct"
                    ><span class="text-black ml-2"
                      >Réponse correcte</span
                    ></vs-checkbox
                  >
                </div>
                <div class="delete_question font-bold">
                  <feather-icon
                    icon="TrashIcon"
                    style="color: red"
                    svgClasses="w-4 h-4 stroke-current"
                    class="mr-1"
                  />
                  <span class="text-danger" @click="removeAnswers(key)"
                    >Supprimer</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-if="form.type_question == 'radio'">
            <div
              class="answer_box mt-4"
              v-for="(item, key) in form.answers"
              :key="key"
            >
              <p class="text-black">Réponse # {{ key + 1 }}</p>
              <vs-textarea
                rows="4"
                v-model="item.answers"
                class="w-full"
              ></vs-textarea
              ><br />
              <div class="w-full" style="display: flex; flex-wrap: wrap">
                <div class="define_question">
                  <vs-switch
                    color="#FFCC00"
                    @change="changeRadio(key)"
                    v-model="item.correct"
                  />
                  <label class="text-black ml-2">Réponse correcte</label>
                </div>
                <div class="delete_question font-bold">
                  <feather-icon
                    icon="TrashIcon"
                    style="color: red"
                    svgClasses="w-4 h-4 stroke-current"
                    class="mr-1"
                  />
                  <span class="text-danger" @click="removeAnswers(key)"
                    >Supprimer</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <vs-button
          v-if="form.type_question && form.type_question !== 'text'"
          @click="addAnswers"
          color="black"
          class="text-white form-button mt-6"
          >Ajouter une réponse</vs-button
        >
      </div>
    </VuePerfectScrollbar>

    <div class="p-2" slot="footer">
      <div class="footer mr-6">
        <vs-row vs-justify="flex-end">
          <vs-button class="black-button"
            @click="isPromptActiveLocal = false"
            >Annuler</vs-button
          >
          <vs-button
            :disabled="isFormValid() ? false : true"
            class="ml-2 text-dark action-button"
            @click="updateQuestion"
            >Modifier</vs-button
          >
        </vs-row>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
const default_form = {
  instructions: null,
  type_question: null,
  question: null,
  answers: null,
};

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "updateQuestionQuizzForm",
  components: { VuePerfectScrollbar },
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    indexEvaluation: {},
    callBackUpdateQuestion: {
      type: Function,
    },
    question: {
      type: Object,
      required: true,
    },
    questionIndex: {
      required: true,
    },
  },
  data() {
    return {
      error_data: [],
      form: {},
      types: [
        { id: "radio", name: "Choix unique" },
        { id: "checkbox", name: "Choix multiple" },
        { id: "text", name: "Texte" },
      ],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
    "form.type_question": function (val, old_val) {
      if (old_val && old_val !== "") {
        if (val == "text") {
          this.form.answers = "";
        } else {
          this.form.answers = [];
        }
      }
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
          //   this.resetErrors();
          this.form = { ...this.question };
          this.error_data = [];
          // console.log(1);
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.form = { ...default_form };
          this.error_data = [];
          this.$emit("closePrompt");
        }
      },
    },
  },
  methods: {
    isFormValid() {
      return (
        this.form.instructions !== "" &&
        this.form.type_question !== "" &&
        this.form.type_question !== "" &&
        this.form.question !== "" &&
        this.validateAnswers()
      );
    },
    validateAnswers() {
      let is_ok = false;
      if (this.form.type_question == "text") {
        is_ok = this.form.answers == "" ? false : true;
      } else if (this.form.type_question == "checkbox") {
        let cpt_correct_values = 0;
        this.form.answers.forEach((element) => {
          if (element.correct == true) cpt_correct_values++;
        });
        is_ok = cpt_correct_values == 0 ? false : true;
      } else if (this.form.type_question == "radio") {
        let correct_value_defined = false;
        this.form.answers.forEach((element) => {
          if (element.correct == true) correct_value_defined = true;
        });
        is_ok = !!correct_value_defined;
      }
      return is_ok;
    },
    changeRadio(e) {
      if (this.form.answers.length > 0) {
        for (let i = 0; i < this.form.answers.length; i++) {
          this.form.answers[i].correct = i === e;
        }
      }
    },
    addAnswers(model) {
      // console.log(this.form.answers);
      if (Array.isArray(this.form.answers)) {
        let index = this.form.answers.push({
          answers: "",
          correct: false,
        });
        //this.changeRadio(index -1)
      } else {
        this.form.answers = [];
        this.form.answers.push({
          answers: "",
          correct: false,
        });
      }
    },
    removeAnswers(index) {
      if (Array.isArray(this.form.answers)) {
        // let index = this.form.answers.indexOf(model);
        this.form.answers.splice(index, 1);
      }
    },
    updateQuestion() {
      this.callBackUpdateQuestion(
        { ...this.form },
        this.questionIndex,
        this.indexEvaluation
      );
      this.$emit("closePrompt");
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    max-width: 681px !important;
  }

  .form-header {
    background-color: #f8f8f8;
    height: 54px;
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

.answer_box {
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px 20px;
  gap: 10px;

  background: #ffffff;
  border: 2px solid #babfc7;
  border-radius: 6px;
}

.define_question {
  text-align: left;
  display: inherit;
  width: 50%;
  float: left;
}

.delete_question {
  text-align: right;
  cursor: pointer;
  width: 50%;
  text-decoration: underline red;
  float: left;
}

.action-button {
  background: #ffcc00 !important;
  border-radius: 25px;
}

.black-button {
  border: 1px solid black;
  background: transparent !important;
  color: black;
  border-radius: 25px;
}
</style>